module.exports = __webpack_public_path__ + "static/media/netflix.8f1153c7.svg";